var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnPhoto = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07031 8.75L2.17969 12.5H13.8203L10.0703 7.5L7.17969 11.25L5.07031 8.75ZM15.5 13.3203C15.5 13.763 15.3307 14.1536 14.9922 14.4922C14.6536 14.8307 14.263 15 13.8203 15H2.17969C1.73698 15 1.34635 14.8307 1.00781 14.4922C0.669271 14.1536 0.5 13.763 0.5 13.3203V1.67969C0.5 1.23698 0.669271 0.846354 1.00781 0.507812C1.34635 0.169271 1.73698 0 2.17969 0H13.8203C14.263 0 14.6536 0.169271 14.9922 0.507812C15.3307 0.846354 15.5 1.23698 15.5 1.67969V13.3203Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnPhoto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-photo.4a7a67db.svg";
export { ForwardRef as ReactComponent };